import { AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';

interface DeleteInvoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  invoiceReference: string;
  isDeleting: boolean;
}

export function DeleteInvoiceModal({
  isOpen,
  onClose,
  onConfirm,
  invoiceReference,
  isDeleting,
}: DeleteInvoiceModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-100">
              <AlertTriangle className="h-5 w-5 text-red-600" />
            </div>
            <DialogTitle className="text-lg font-semibold">Supprimer la facture</DialogTitle>
          </div>
        </DialogHeader>

        <div className="space-y-3 pt-2">
          <DialogDescription className="text-sm text-slate-600">
            Êtes-vous sûr de vouloir supprimer la facture{' '}
            <code className="rounded bg-slate-100 px-1.5 py-0.5 font-mono text-xs font-semibold text-slate-900">
              {invoiceReference}
            </code>{' '}
            ?
          </DialogDescription>
          <div className="rounded-lg border border-red-200 bg-red-50 p-3">
            <p className="text-sm font-medium text-red-800">⚠️ Cette action est irréversible</p>
            <p className="mt-1 text-xs text-red-600">La facture sera définitivement supprimée de la base de données.</p>
          </div>
        </div>

        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="outline" onClick={onClose} disabled={isDeleting} className="flex-1">
            Annuler
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isDeleting} className="flex-1">
            {isDeleting ? (
              <>
                <span className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                Suppression...
              </>
            ) : (
              'Supprimer'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
